import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Sleep Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing sleep data, error, loading state, and score
 *
 */
export const useOptimizedSleep = () => {
  const { error, loading, sleep } = useOuraData();

  return {
    error,
    loading,
    score: sleep?.score ?? 0,
    sleep,
  };
};
